import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import Affix from '../../../../../../components/affix'
import ColoredTip from '../../../../components/tips/colored-tip/closeable'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { FormattedMessage, useIntl } from 'react-intl'

export default props => {
    useStyles(classes)
    const { mostPreferredCoupon, onClose, onClick } = props
    const intl = useIntl()
    return mostPreferredCoupon ? <Affix offsetTop={44}>
        <ColoredTip icon={<Iconfont className={classes.Icon}>&#xe6d9;</Iconfont>} backgroundColor="#FFF8EB" onClick={onClick} onClose={onClose}>
            <span onClick={onClick} className={classes.Content} dangerouslySetInnerHTML={{
                __html: intl.formatMessage({id: 'use_max_coupon', defaultMessage: "Don't forget to use the {coupon} coupon!"}, {coupon: `<b>${mostPreferredCoupon?.name}</b>`})
            }}/>
        </ColoredTip>
    </Affix> : <></>
}